import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, bytesToSize, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';
import VideoPlayer from '../components/video/video';
import AudioPlayer from '../components/video/audio';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';
import AudioWaveform from '../components/video/waveform';
import axios from 'axios';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';

//import './css/stream.css';
//import './css/header.css';

class PortalServiceReplays extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: this.props.service,
				name: '',
			},

			

      //servicekey: '',
			replays: [],
			publish: {},
			
      
		};
    this.getReplays = this.getReplays.bind(this);
		this.download = this.download.bind(this);
  };

  async componentDidMount() {
		//document.title = "";

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		//value.worker[this.props.service] || y[this.props.service];
		
		//value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', y);

		
		this.getReplays();
		
   
		
	}

	componentWillUnmount() {
    
	}

	async getReplays() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/replays`, params);
		consoleLog(x.data);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Replays', x.data.servicename);
			}
			this.setState({replays: x.data.replays, publish: x.data.publish});
		}
	}


	async download(file) {
		try {
			
			
			/*const response = await fetch(file, {mode: 'cors', headers: {withCredentials: true}});
			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = file.split('/').pop();
			link.click();
			URL.revokeObjectURL(blobUrl);
			*/

			axios({
				url: file,
				method: 'GET',
				responseType: 'blob', // important
				withCredentials: true,
				onDownloadProgress: (event=>{
					
				})
			}).then((response) => {
				// create file link in browser's memory

				

				const href = URL.createObjectURL(response.data);
		
				// create "a" HTML element with href to file & click
				const link = document.createElement('a');
				link.href = href;
				link.setAttribute('download', file.split('/').pop()); //or any other extension
				document.body.appendChild(link);
				link.click();
		
				// clean up "a" element & remove ObjectURL
				document.body.removeChild(link);
				URL.revokeObjectURL(href);
		});

		} catch (error) {
			console.error('Error downloading the image:', error);
		}
	}
  
	render() {
		const user = this.context;

		//const value = this.context;

		const publish = Object.keys(this.state.publish).map((e,i) => {
			//return 
				return (
					<React.Fragment key={i}>
						<Dropdown.Item key={i} eventKey="0" style={{width: 200}} disabled={true}>{String(e).charAt(0).toUpperCase() + String(e).slice(1)}</Dropdown.Item>
						{Object.keys(this.state.publish[e]).map((f,j) => {
							return this.state.publish[e][f].map((g,k) => {
								return (
									<Dropdown.Item eventKey="1" style={{width: 200}}>{/*g.id*/} {g.username}</Dropdown.Item>
								)
							})
						})}
					</React.Fragment>
				)/*this.state.publish[e][f].map((g,k) => {
					return (
						<Dropdown.Item eventKey="1" style={{width: 200}}>{g.id} {g.username}</Dropdown.Item>
					)
				})*/
			//});
		});

		const replays = this.state.replays.map((e,i) => {
			return (
				<Col xs={12} key={i}>
					<div className="card custom-card">
						<div className="card-header justify-content-between py-2">
							<div className="card-title">
								{e.showname}
							</div>
						</div>
						<div className="card-body">
							<Row className="gx-0">
								<Col xs={12} md={4} className="me-2">
									{e.access === true ?
										<VideoPlayer
											id="video"
											//service={this.state.service.id} //{this.state.select.address}
											//select={this.state.select_temp.select}
											//uid={this.state.stage.live?.uid}
											theatre={()=>{}}
											onError={()=>{}}
											height={100}
											url={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename}?d=${Math.floor(Date.now()/1000)}`}
											controls={true}
											muted={false}
											autoPlay={false}
										/>
									:
										<>
											<img src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','png')}?d=${Math.floor(Date.now()/1000)}`} crossOrigin="use-credentials" width="100%" alt="Replay Avatar" />
											<AudioPlayer src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','m4a')}?d=${Math.floor(Date.now()/1000)}`} />
										</>
									}
									
									{/*<img src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/screenshot.png?d=${Math.floor(Date.now()/1000)}`} crossOrigin="use-credentials" width="100%" />*/}
								</Col>
								<Col>
									<h4>{e.access === true ?'Video':'Audio'}: {e.showname.replaceAll(' ','')}</h4>
									<h5>Statistics</h5>
									<h5>Track Listings</h5>
									<h5>Audio Waveform</h5>

									<AudioWaveform
										url={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','dat')}?d=${Math.floor(Date.now()/1000)}`}
										barWidth={2}
										height={50}
										color="#3E5151"
										progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
									/>

								</Col>
							</Row>
							
						</div>
						<div className="card-footer py-2">
							<div className="float-end">
								<ButtonGroup size="sm">
							 		<Button size="sm">Analytics</Button>
									{e.access === true &&
									 	<DropdownButton as={ButtonGroup} id={`dropdown-publish`} title="Publish &#9660;" size="sm">
											{publish}
											{/*<Dropdown.Item eventKey="1" style={{width: 200}}>Company Mixcloud</Dropdown.Item>
											<Dropdown.Item eventKey="2" style={{width: 200}}>Personal Mixcloud</Dropdown.Item>*/}
										</DropdownButton>
									}
									<DropdownButton as={ButtonGroup} id={`dropdown-downloads`} title="Download &#9660;" size="sm">
										{e.access === true &&
											<Dropdown.Item eventKey="1" style={{width: 200}} disabled={e.video_mp4===0?true:false} onClick={()=>this.download(`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.showname.replaceAll(' ','')}.mp4?d=${Math.floor(Date.now()/1000)}`)}>Video MP4 ({e.video_mp4===0?'Waiting':bytesToSize(e.video_mp4)})</Dropdown.Item>
										}
										<Dropdown.Item eventKey="2" style={{width: 200}} disabled={e.audio_mp3===0?true:false} onClick={()=>this.download(`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','mp3')}?d=${Math.floor(Date.now()/1000)}`)}>Audio MP3 ({e.audio_mp3===0?'Waiting':bytesToSize(e.audio_mp3)})</Dropdown.Item>
										<Dropdown.Item eventKey="2" style={{width: 200}} disabled={e.audio_m4a===0?true:false} onClick={()=>this.download(`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${e.schedule}/${e.filename.replace('mp4','m4a')}?d=${Math.floor(Date.now()/1000)}`)}>Audio M4A ({e.audio_m4a===0?'Waiting':bytesToSize(e.audio_m4a)})</Dropdown.Item>
										{/*<Dropdown.Divider />*/}
										{/*<Dropdown.Item eventKey="4">Separated link</Dropdown.Item>*/}
									</DropdownButton>
									
								</ButtonGroup>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Replays</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Video Replays</span>
													<p className="fs-13 text-muted mb-0">View your recordings and stream analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row>
								{replays}
							</Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Replays = props => {
  const { service } = useParams();
  return <PortalServiceReplays service={service} {...props} />
}
export default Replays;